import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { layoutContentMaxWidthPx } from '../../shared/style-settings'

export const usePageWrapperStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageWrapper: {
      marginTop: '20px',
      maxWidth: layoutContentMaxWidthPx,
      margin: '0 auto',
    },
    titleRow: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: theme.spacing(2),
      rowGap: theme.spacing(1),
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    titleRowEndOnly: {
      justifyContent: 'flex-end',
    },
    pageTitle: {
      fontWeight: 700,
      marginBottom: 0,
      textAlign: 'left',
      fontSize: '1.5rem',
      lineHeight: 1.3,
      flex: '1 1 auto',
      minWidth: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: '1.2125rem',
        lineHeight: 1.35,
      },
    },
    titleEnd: {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
  })
)
